import { FrontendApi, Configuration } from "@ory/client"

export const KRATOS_PUBLIC_URL =
  (typeof import.meta !== "undefined" &&
    import.meta.env?.VITE_KRATOS_PUBLIC_URL) ||
  (typeof process !== "undefined" && process.env?.VITE_KRATOS_PUBLIC_URL) ||
  "http://auth.malond.local"

export const kratosClient = new FrontendApi(
  new Configuration({
    basePath: KRATOS_PUBLIC_URL,
    baseOptions: {
      withCredentials: true,
    },
  })
)
